module.exports = __webpack_public_path__ + "static/media/csharp.7e991e2a.svg";